import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { KRA } from './kratypes';


export const createKRA = createAsyncThunk(
    'performance/createKRA',
    async (data: KRA, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/performance/kra', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create KRA');
      }
    }
  );

  export const fetchAllKRA = createAsyncThunk(
    'performance/fetchAllKRA',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/performance/kra');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all KRA');
        }
    }
);

export const fetchKRAById = createAsyncThunk(
    'performance/fetchKRAById',
    async (KRAId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/kra/${KRAId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch KRA');
        }
    }
);

export const deleteKRA = createAsyncThunk(
    'performance/deleteKRA',
    async (KRAId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/performance/kra/${KRAId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete KRA');
        }
    }
);

export const updateKRA = createAsyncThunk<any , {KRAId: number; data: any}, { rejectValue: string }>(
    'performance/updateKRA',
    async ({KRAId , data}: {KRAId : Number; data: Partial<any>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/performance/kra/${KRAId}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create KRA');
      }
    }
  ); 

